import { Button, Dialog, DialogActions, Paper, styled, Theme } from '@material-ui/core';

export const VideoPageHelperPaper = styled(Paper)<Theme, { open: boolean }>(({ theme, open }) => ({
  position: 'absolute',
  left: 0,
  bottom: 0,
  margin: '0 0 16px 16px',
  borderRadius: 8,
  backgroundColor: theme.palette.genevaGreen,
  color: theme.palette.white,
  padding: '8px 16px 12px 16px',
  width: open ? '336px' : 'min-content',
  zIndex: 1000,
  maxWidth: open ? 'unset' : '180px',
}));

export const VideoPageHelperTitle = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '8px 16px 12px 0px',
  whiteSpace: 'nowrap',
}));

export const VideoWrapper = styled('div')<Theme>(({ theme }) => ({ padding: '8px 0px 12px 0px' }));

export const VideoPageHelperDialog = styled(Dialog)<Theme>(({ theme }) => ({
  '& .MuiDialog-root': {
    position: 'absolute',
    left: 0,
    bottom: 0,
  },
  '& MuiDialog-container': {
    position: 'absolute',
  },
  '& .MuiDialog-scrollPaper': {
    alignItems: 'end',
    justifyContent: 'flex-start',
  },
  '& .MuiBackdrop-root': {
    backgroundColor: 'transparent',
    pointerEvents: 'none',
  },
  '& .MuiPaper-root.MuiDialog-paper': {
    backgroundColor: theme.palette.genevaGreen,
    color: theme.palette.white,
    padding: '8px 16px',
  },
  '& .MuiDialog-paper': {
    margin: 24,
    borderRadius: 8,
  },
}));

export const VideoPageHelperDialogActions = styled(DialogActions)<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 0,
}));

export const VideoPageHelperDialogButtons = styled(Button)<Theme>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  color: theme.palette.white,
  fontFamily: 'Poppins',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '24px',
  textTransform: 'none',
  '& .MuiButton-label': {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  whiteSpace: 'nowrap',
}));
